export default "__VITE_ASSET__BtCc2$yl__"